import React, { useState } from 'react';
import './Calendar.css';
import {useEffect} from "react";

const Calendar = (props) => {
    
  
    
    const today = new Date();
    const [currentMonth, setCurrentMonth] = useState(today.getMonth());
    const [currentYear, setCurrentYear] = useState(today.getFullYear());
    const [selectedDay, setSelectedDay] = useState(today.getDate());

    
    const months = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];

    const renderCalendar = (month, year) => {
        const firstDay = new Date(year, month, 1).getDay();
        const daysInMonth = new Date(year, month + 1, 0).getDate();

        let dates = [];
        for (let i = 0; i < firstDay; i++) {
            dates.push(<div key={`empty-${i}`} className="empty"></div>);
        }
        var className = "dates";
       
        for (let day = 1; day <= daysInMonth; day++) {

           
            if(day===selectedDay){
                dates.push(<div key={day} onClick={()=>changeActiveDate(day)} className={"selectedDate"}>{day}</div>);
            }else{

                dates.push(<div key={day} onClick={()=>changeActiveDate(day)} className={checkIfDatesInSchedule(day)? "dates":"disabled"}>{day}</div>);
            
            }
        }

        return dates;
    };

    function checkIfDatesInSchedule(day){
        if(day<=9){
            day="0"+day;
        }
        let dateStringTocheck = currentYear+""+(currentMonth+1)+""+day;
        if(currentMonth<=9){
            dateStringTocheck = currentYear+"0"+(currentMonth+1)+""+day;
        }
       
        console.log("Calender check date");
        console.log(dateStringTocheck); 
        
        var index = props.jsonRes.findIndex((show)=>{ 
              
           
            return show.date === dateStringTocheck;

        });

        if(index==(-1)){
            return false;
        }else{
            return true;
        }
        
    }
 const changeActiveDate =(day)=>{
    setSelectedDay(day);
    props.setActiveDate((previousState)=>{
        previousState.day = day;
        previousState.month = (currentMonth+1);
        previousState.year = (currentYear);
        
        return {...previousState}
    });
    props.ScrollToAllShows();
   
    
 }
    const prevMonth = () => {
        setCurrentMonth(prev => {
            if (prev === 0) {
                setCurrentYear(year => year - 1);
                return 11;
            } else {
                return prev - 1;
            }
        });
    };

    const nextMonth = () => {
        setCurrentMonth(prev => {
            if (prev === 11) {
                setCurrentYear(year => year + 1);
                return 0;
            } else {
                return prev + 1;
            }
        });
    };


   
    
if (props.showCalendar==false) return null;

    return (
       <>
       <div className='popup-overlay' onClick={props.handleShowCalendar} > </div>
          <div id="calendarHolder"  > 
           
            <div id="calendar-container">
                <div id="calendar-header">
                    <button onClick={prevMonth}>&lt;</button>
                    <span id="month-year">{`${months[currentMonth]} ${currentYear}`}</span>
                    <button onClick={nextMonth}>&gt;</button>
                </div>
                <div id="calendar-body">
                    <div className="day-names">
                        <div>Sun</div>
                        <div>Mon</div>
                        <div>Tue</div>
                        <div>Wed</div>
                        <div>Thu</div>
                        <div>Fri</div>
                        <div>Sat</div>
                    </div>
                    <div id="calendar-dates">
                        {renderCalendar(currentMonth, currentYear)}
                    </div>
                </div>
                </div>
                <h3 onClick={props.handleShowCalendar} id="calendarCancelButton">&#10006;</h3>
            
        </div>
       
        </>
        
    );
};

export default Calendar;